export interface DashboardDataState {
    dashboardData: any;
}

export const initialDashboardDataState: DashboardDataState = {
    dashboardData: null
};
